import moment from 'moment';
import { formatDateTimeHours } from './globalFunction';

export default function RecentLeaveCollection(getRecentLeave, intl) {
    var recentLeaves = []
    for (var i = 0; i < getRecentLeave.length; i++) {
        recentLeaves.push({
            id: `${getRecentLeave[i].id}`,
            type: `${intl.formatMessage({ id: 'guideline.' + getRecentLeave[i].type.name })}`,
            startDate: `${getRecentLeave[i].start_date}`,
            startTime: formatDateTimeHours(getRecentLeave[i], 'startTime', intl),
            untilDate: `${getRecentLeave[i].until_date}`,
            endTime: formatDateTimeHours(getRecentLeave[i], 'endTime', intl),
            period: formatDateTimeHours(getRecentLeave[i], 'period', intl),
            status: `${intl.formatMessage({ id: 'status.' + getRecentLeave[i].status })}`,
        });
    }

    return recentLeaves;
}